<template>
  <div class="info">
    <a-row>
      <a-col :span="16" :offset="4">
        <div class="left">
          <div class="header">
            <div class="avatar" @click="$refs.resource.open(1, 'avatar')">
              <img v-if="!modelRef.avatar" src="@/assets/add.png" alt="" />
              <img v-else :src="modelRef.avatar" :alt="modelRef.name" />
            </div>
          </div>
          <div class="nickname">
            {{ user.username }}
          </div>
          <a-spin tip="Loading..." :spinning="loading">
            <a-form>
              <e-input
                title="姓名"
                :validate="validateInfos.name"
                v-model:value="modelRef.name"
              />

              <e-input
                title="手机号"
                :validate="validateInfos.mobile"
                v-model:value="modelRef.mobile"
              />

              <e-date-time
                title="生日"
                :validate="validateInfos.birthDay2"
                v-model:value="modelRef.birthDay2"
              />

              <e-radio
                title="性别"
                v-model:value="modelRef.sex"
                :options="$store.state.app.sexes"
              />
            </a-form>
          </a-spin>

          <div class="btns">
            <a-button
              block
              type="primary"
              @click="onSubmit((e) => onSubmitFun(e))"
              :loading="loading"
              style="width: 370px"
            >
              保存
            </a-button>
          </div>
        </div>
      </a-col>
    </a-row>

    <Resource ref="resource" @ok="emitChooseResource" />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, toRaw } from 'vue'
import { Form } from 'ant-design-vue'
import form from '@/mixins/form'
import { UserClass } from '@/apis/user'
import Resource from '@/components/Resource'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')

const useForm = Form.useForm
const api = new UserClass()
export default defineComponent({
  components: {
    Resource
  },
  mixins: [form],
  setup () {
    const loading = ref(false)
    const user = ref({})

    const modelRef = reactive(api.modelRef)
    const rulesRef = reactive(api.rulesRef)

    const { resetFields, validate, validateInfos } = useForm(
      modelRef,
      rulesRef
    )

    return {
      loading,
      user,
      modelRef,
      resetFields,
      validate,
      validateInfos
    }
  },

  created () {
    this.user = this.$store.state.user.userInfo

    this.modelRef.username = this.user.username
    this.modelRef.mobile = this.user.mobile
    this.modelRef.name = this.user.name
    this.modelRef.sex = this.user.sex
    this.modelRef.birthDay2 = this.user.birthDay ? dayjs(this.user.birthDay) : null
    this.modelRef.avatar = this.user.avatar
    this.modelRef.wechartName = this.user.wechartName
    this.modelRef.wechartNum = this.user.wechartNum
    this.modelRef.roleId = this.user.roleIds[0]
    this.modelRef.password = '密码'
    this.modelRef.password_confirm = '密码'
    this.modelRef.id = this.user.id
  },

  methods: {
    onSubmitFun () {
      const data = toRaw(this.modelRef)

      const entity = {}
      entity.id = data.id
      entity.name = data.name
      entity.sex = data.sex
      entity.birthDay = data.birthDay2 ? data.birthDay2.format('YYYY-MM-DD') : null
      entity.avatar = data.avatar
      entity.mobile = data.mobile

      api
        .updateSelf(entity)
        .then(() => {
          this.loading = false
          this.$message.success('编辑成功')

          Object.assign(this.user, data)
          this.$store.commit('SET_INFO', this.user)
        })
        .catch(() => {
          this.loading = false
        })
    },

    emitChooseResource (e) {
      const image = e.images[0]
      this.modelRef.avatar = image
    }
  }
})
</script>

<style lang="less" scoped>
.info {
  padding: 10px;
  height: 100%;
  overflow: auto;
  .left {
    padding-top: 30px;
    .header {
      display: flex;
      justify-content: center;
      .avatar {
        width: 150px;
        height: 150px;
        border: 1px solid rgb(221, 220, 220);
        background: #f1f1f1;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .nickname {
      text-align: center;
      line-height: 30px;
      font-size: 16px;
      padding-top: 30px;
    }

    .btns {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
